var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_483_1443",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_483_1443",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACTklEQVR4nO2dsWpUQRSGB7QV8gBWRhEEC8ukWTZzsMzeOeHWAeM9SZ4i76OiWGkaX0J9DFGjjYUoQ7Q0rFvsn535PjjNbrHD/82Z2WWZuSkBAAAAAAAAAGwGs9nZzXEcb6jH0R354OSRlXiXy/TTPH5dp8olPplPzx+PR3dTi8yH2LYyfVMHbUuIyH56J7VG9nitDteWrulNao1c4rs+2Fi+E4bYSS2hDtT+fyl6m1pCHaitUPODaTe1gjpMW6ULfHq/u//kVmoBdZi2apXp457HMFscbqVNRh6kX7u6yB4v5+PJfQS49nfHrDy9TQe4UILHMwS4sgumrwhw7Z6AAEdA15X4GhoIUM9CowP0QRhLkD4MExR7gCNAPguNDtAHYSxB+jBMUOwBjgD5LDQ6QB+EsQTpwzBBsQc4AuSz0OgAfRDGEqQPwwTFHuAIkM9CowP0QRhLkD4MExR7gCNAPguNDtAHYSxB+jBMUOwBjgD5LDQ6QB+EsQTpwzBBsQd45wLSGpktDresTPtW4oM6+C4F/KUeQa1HUdXhdyugUg9jq8PvWkClXkuAACF5iB2pgBJfuu6ASr2iRijgRepdwHyI7ctbs9Yb/uVnHt9LvQuo1OvK6qHpdYioZ4PrzF9L+JsioGkQIAYBYhAgBgFiECAGAWIQIAYBYhAgBgFiECAGAWIQIAYBYhAgpv7veYWEz+rxNc+VjzAp8Uo9vubZG48f/OMhPhf1PfX4usAW8TCXOM8lfvyp8/qaelzdUR/ixoPcAAAAAAAAAADSpvAb4GeJO9RBpHkAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportFlag);
export default __webpack_public_path__ + "static/media/reportFlag.5c312bca87d648421e85b47515af0f5a.svg";
export { ForwardRef as ReactComponent };